import { useTheme } from '@/contexts/ThemeContext/useTheme';
import { useUser } from '@/hooks/user/useUser';
import { LanguageSwitcher } from '@/components/LanguageSwitcher/LanguageSwitcher';
import { useTranslation } from 'react-i18next';
import { FooterBody } from './FooterBody';
import { footerStrings } from './footerStrings';
import { shouldReloadForLocale } from '@/lib/locale';

/**
 * Logged-out and mid-onboarding users are pinned to the light theme by
 * ThemeProvider, so the stored `theme` alone isn't enough to pick a logo.
 */
const useDarkLogos = () => {
    const { user } = useUser();
    const { theme } = useTheme();
    return Boolean(user) && theme === 'dark';
};

/** The SPA footer: the viewer-dependent parts and copy from hooks, the markup from FooterBody. */
export const Footer = () => {
    const { t } = useTranslation();
    return (
        <FooterBody
            darkLogos={useDarkLogos()}
            languageSwitcher={<LanguageSwitcher />}
            strings={footerStrings(t)}
            reloadLinks={shouldReloadForLocale()}
        />
    );
};
